import { useEffect, useState } from 'react';

export const isIE = () => {
    if (typeof window !== 'undefined') {
        const userAgent = window.navigator.userAgent;
        return userAgent.indexOf('Trident/') > 0;
    }
    // Returning false if window is undefined
    return false;
};

function generateUseClientStateHook<T>(initializer: () => T, defaultValue: T) {
    return () => {
        const [state, setState] = useState(defaultValue);
        useEffect(() => {
            setState(initializer());
        }, []);
        return state;
    };
}

const isWindows = () => typeof window !== 'undefined' && window.navigator.userAgent.includes('Windows NT');
const isMac = () => typeof window !== 'undefined' && window.navigator.userAgent.includes('Macintosh');

export const useIsWindows = generateUseClientStateHook(isWindows, false);
export const useIsMac = generateUseClientStateHook(isMac, false);
export const useIsClient = generateUseClientStateHook(() => typeof window !== 'undefined', false);
